import { container } from '@/container';

/**
 * Format a contact's name, with a tile where appropriate.
 *
 * NOTE: This filter is not globally available in Vue. You must import it where needed.
 *
 * @param {Contact} contact
 *
 * @returns {string}
 */
export const contactNameFilter = (contact) => {
    let nameParts = [];

    if (container.userService.company.shouldCaptureTitles()) {
        nameParts.push(contact.title);
    }

    nameParts.push(contact.firstName);
    nameParts.push(contact.lastName);

    return nameParts.filter((p) => !!p).join(' ');
};
